/**
 * PROTOTYPE host page -- THROWAWAY. Route: /prototype/spread-split
 *
 * Question: does the "split a proposal into spreads" design work when wired into
 * the existing master/detail + cost-override-drawer workflow?
 *
 * Guided flow (SpreadFlow): a left step-rail you can follow or jump around in --
 * Project (metadata) -> Spreads (how many + sizes) -> Configure (module rail +
 * detail pane + Edit-overrides drawer per spread) -> Services (platform services +
 * rate cards) -> Review (document style + generated files). Every spread and the
 * project services price live from the engine, shown as a running project total.
 */
import React, { useState, useEffect } from 'react';
import { CRC } from '../prototype/moduleInputsData';
import { ProjectState } from './spreadSplitData';
import { initialProject } from './spreadSeed';
import { SpreadFlow } from './SpreadFlow';
import { useLiveDefaults } from './spreadLiveConfig';

const SpreadSplitPrototype: React.FC = () => {
  const [project, setProject] = useState<ProjectState>(initialProject);
  // Show the engine's real config as the drawer defaults (MT + NDT + Coating).
  const live = useLiveDefaults();
  useEffect(() => {
    if (live) setProject((p) => ({ ...p, liveDefaults: { ...p.liveDefaults, ...live } }));
  }, [live]);
  return (
    <div style={{ background: CRC.pageBg, minHeight: '100%', fontFamily: 'Montserrat, sans-serif', padding: '24px 16px 60px' }}>
      <SpreadFlow project={project} setProject={setProject} />
    </div>
  );
};

export default SpreadSplitPrototype;
